import { render, staticRenderFns } from "./PopoverLista.vue?vue&type=template&id=05140169"
import script from "./PopoverLista.vue?vue&type=script&lang=js"
export * from "./PopoverLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports